const Loader = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full z-[1000]">
      <img
        src="https://www.frontendplanet.com/images/code-snippets/css-loader/video/smiley-preloader.png"
        alt="Loading..."
        className="w-full h-full object-cover"
      />
    </div>
  )
}

export default Loader
